import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Store for scroll positions
const scrollPositions = new Map<string, number>();

export function ScrollRestoration() {
  const location = useLocation();

  useEffect(() => {
    // Restore scroll position when navigating back
    const savedPosition = scrollPositions.get(location.pathname + location.search);
    
    if (savedPosition !== undefined) {
      // Small delay to ensure DOM is ready
      requestAnimationFrame(() => {
        window.scrollTo(0, savedPosition);
      });
    } else {
      // Scroll to top for new pages
      window.scrollTo(0, 0);
    }

    // Save scroll position before leaving
    return () => {
      scrollPositions.set(location.pathname + location.search, window.scrollY);
    };
  }, [location.pathname, location.search]);

  return null;
}
